function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
import { MediaQueryObserver } from './MediaQueryObserver';
export class MediaQueryManager {
    getObserver(query) {
        let observer = this.registry.get(query);
        if (!observer) {
            observer = new MediaQueryObserver(query);
            this.registry.set(query, observer);
        }
        return observer;
    }
    matchMedia(query) {
        const observer = this.getObserver(query);
        return {
            matches: observer.matches
        };
    }
    addQueryListener(query, listener) {
        const observer = this.getObserver(query);
        observer.subscribe(listener);
        return ()=>this.removeQueryListener(query, listener);
    }
    removeQueryListener(query, listener) {
        const observer = this.registry.get(query);
        if (observer === null || observer === void 0 ? void 0 : observer.unsubscribe(listener)) {
            this.registry.delete(query);
        }
    }
    constructor(){
        _define_property(this, "registry", void 0);
        this.registry = new Map();
    }
}
export const mediaQueryManager = new MediaQueryManager();

//# sourceMappingURL=MediaQueryManager.js.map